import { debug } from '../../utils/debug';
import { rideshareData } from './rideshare';
import { cyclecentralData } from './cyclecentral';

const DEFAULT_MERCHANT_ID = 'rideshare';

// Static merchant data without any processing
const merchants = {
  rideshare: rideshareData,
  cyclecentral: cyclecentralData,
};

// Simple function to get merchant data and add filter options
export const getMerchantData = (merchantId) => {
  debug.log('getMerchantData called with:', merchantId);
  debug.log('Available merchants:', Object.keys(merchants));
  
  const normalizedId = merchantId?.toLowerCase();
  const merchant = merchants[normalizedId] || merchants[DEFAULT_MERCHANT_ID];
  
  if (!merchant) {
    console.error("No merchant found for ID:", merchantId);
    return merchants[DEFAULT_MERCHANT_ID];
  }

  if (!merchant.bikes) {
    console.error("Invalid merchant data - no bikes:", merchantId);
    return merchants[DEFAULT_MERCHANT_ID];
  }

  debug.log('Found merchant:', merchant.config?.name);

  // Generate filter options on demand without mutating original data.
  // Category options are {value, label} pairs; static merchants have no
  // category ids, so the (hardcoded, untranslated) name doubles as the value.
  const categories = [{ value: '', label: 'All Categories' }];
  const bikeModels = ['All Models'];
  const sizes = ['All Sizes'];

  // Safe iteration over bikes
  try {
    merchant.bikes.forEach(bike => {
      if (bike.category && !categories.some(c => c.value === bike.category)) {
        categories.push({ value: bike.category, label: bike.category });
      }
      if (bike.name && !bikeModels.includes(bike.name)) {
        bikeModels.push(bike.name);
      }
      if (bike.sizes && Array.isArray(bike.sizes)) {
        bike.sizes.forEach(sizeInfo => {
          const sizeMap = {
            'S': 'Small (S)',
            'M': 'Medium (M)', 
            'L': 'Large (L)',
            'XL': 'Extra Large (XL)',
          };
          const displaySize = sizeMap[sizeInfo.size] || sizeInfo.size;
          if (!sizes.includes(displaySize)) {
            sizes.push(displaySize);
          }
        });
      }
    });
  } catch (error) {
    console.error("Error processing merchant data:", error);
  }

  const result = {
    ...merchant,
    filterOptions: {
      categories,
      bikeModels,
      sizes,
    },
  };

  debug.log('Returning merchant data with filter options:', result);
  return result;
};